import { Component } from '@angular/core';

@Component({
  selector: 'kui-content-header-actions',
  templateUrl: './content-header-actions.component.html',
})
export class KuiContentHeaderActionsComponent { }
